import React, { useState } from "react";
import "../Style/Collapase.css";

const CollapseCard = ({ title, footer, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;

  return (
    <div className="collapse-card">
      <div className="collapse-card-header">
        <h3 className="collapse-card-title">{title}</h3>

        <div className="collapse-card-tools">
          <button
            type="button"
            className="btn-tool"
            title="Collapse"
            onClick={() => setIsCollapsed(!isCollapsed)}
          >
            <i className={`fas ${isCollapsed ? "fa-plus" : "fa-minus"}`}></i>
          </button>
          <button
            type="button"
            className="btn-tool"
            title="Remove"
            onClick={() => setIsVisible(false)}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
      </div>

      {!isCollapsed && (
        <div className="collapse-card-body">
          <div className="collapse-card-scroll">{children}</div>
        </div>
      )}

      {!isCollapsed && footer && (
        <div className="collapse-card-footer">{footer}</div>
      )}
    </div>
  );
};

export default CollapseCard;
